import { media } from '@displate/styleguide';
import styled from 'styled-components';

import { customMediaQueries } from '@/common/constants/customMediaQueries';

export const FooterSectionWrapper = styled.section`
  && {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 32px 0 48px 0;
    margin: 0 16px 0 16px;
    gap: 16px;

    ${media.medium} {
      gap: 24px;
      padding: 56px 0 88px 0;
      flex-direction: row;
      margin: 0 48px 0 48px;

      div:nth-child(1) {
        order: 2;
      }

      div:nth-child(2) {
        order: 1;
      }

      div:nth-child(3) {
        order: 3;
      }
    }

    ${customMediaQueries.width1920} {
      margin: 0 80px 0 80px;
    }
  }
`;
